(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alvette-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initHero(root) {
    if (!root || root.dataset.alvHeroReady === '1') return;
    root.dataset.alvHeroReady = '1';

    var slides = root.querySelectorAll('.alv-hero__slide');
    var dots = root.querySelectorAll('.alv-hero__dot');
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;
    var delay = parseInt(root.getAttribute('data-alv-autoplay'), 10) || 0;
    var reduce = null;

    try {
      reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    } catch (e) {
      reduce = null;
    }

    function show(next) {
      index = ((next % slides.length) + slides.length) % slides.length;

      for (var i = 0; i < slides.length; i++) {
        var on = i === index;
        slides[i].classList.toggle('is-active', on);
        slides[i].setAttribute('aria-hidden', on ? 'false' : 'true');
      }

      for (var j = 0; j < dots.length; j++) {
        var active = j === index;
        dots[j].classList.toggle('is-active', active);
        if (active) dots[j].setAttribute('aria-current', 'true');
        else dots[j].removeAttribute('aria-current');
      }
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!delay) return;
      if (reduce && reduce.matches) return;
      if (document.hidden) return;
      timer = setInterval(function () {
        show(index + 1);
      }, delay);
    }

    for (var d = 0; d < dots.length; d++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var target = parseInt(btn.getAttribute('data-alv-dot'), 10) || 0;
          show(target);
          start();
        });
      })(dots[d]);
    }

    // Lightweight horizontal swipe (mobile), ignores vertical scrolls.
    var sx = 0;
    var sy = 0;
    root.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || !e.touches.length) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      function (e) {
        if (!e.changedTouches || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          show(dx < 0 ? index + 1 : index - 1);
          start();
        }
      },
      { passive: true }
    );

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    root.alvHeroShow = show;
    show(0);
    start();
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    var heroes = container.querySelectorAll('[data-alv-hero]');
    for (var i = 0; i < heroes.length; i++) initHero(heroes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var block = e.target;
    if (!block || !block.classList || !block.classList.contains('alv-hero__slide')) return;
    var root = block.closest('[data-alv-hero]');
    if (!root || typeof root.alvHeroShow !== 'function') return;
    var siblings = root.querySelectorAll('.alv-hero__slide');
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] === block) {
        root.alvHeroShow(i);
        break;
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alvette-product-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  var READY = 'alvPtabsReady';

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-alv-ptabs]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  function init(root) {
    if (!root || root.dataset[READY] === '1') return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (tabs.length < 1 || panels.length !== tabs.length) return;

    root.dataset[READY] = '1';
    var viewAll = root.querySelector('[data-alv-ptabs-viewall]');

    function activate(index, moveFocus) {
      if (index < 0) index = tabs.length - 1;
      if (index >= tabs.length) index = 0;

      for (var i = 0; i < tabs.length; i++) {
        var on = i === index;
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[i].setAttribute('tabindex', on ? '0' : '-1');
        if (on) {
          panels[i].removeAttribute('hidden');
        } else {
          panels[i].setAttribute('hidden', '');
        }
      }

      var current = tabs[index];
      if (viewAll && viewAll.getAttribute('data-follow') === 'true' && current.dataset.url) {
        viewAll.setAttribute('href', current.dataset.url);
      }
      if (moveFocus) {
        current.focus();
        if (current.scrollIntoView) {
          try { current.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {}
        }
      }
    }

    root.activateAlvTab = activate;

    for (var t = 0; t < tabs.length; t++) {
      (function (idx) {
        tabs[idx].addEventListener('click', function () { activate(idx, false); });
      })(t);
    }

    root.addEventListener('keydown', function (event) {
      var idx = tabs.indexOf(event.target);
      if (idx === -1) return;
      var key = event.key;
      if (key === 'ArrowRight') { activate(idx + 1, true); }
      else if (key === 'ArrowLeft') { activate(idx - 1, true); }
      else if (key === 'Home') { activate(0, true); }
      else if (key === 'End') { activate(tabs.length - 1, true); }
      else { return; }
      event.preventDefault();
    });

    // Sync the "View all" link with the tab that is active on load.
    activate(0, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (!block) return;
    var root = block.closest ? block.closest('[data-alv-ptabs]') : null;
    if (!root || typeof root.activateAlvTab !== 'function') return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var id = block.getAttribute('data-block-id') || (event.detail && event.detail.blockId);
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].getAttribute('data-block-id') === id) { root.activateAlvTab(i, false); return; }
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
